module.exports = __webpack_public_path__ + "static/media/horrormax-banner-ice-cream-man.c4335841.jpg";